import React, { useState } from 'react';
import Navbar from '../components/Navbar.js';
import Footer from '../components/Footer.js';
import 'bootstrap/dist/css/bootstrap.min.css';
import BannerImage from '../components/img/video-consultation-banner.png';
import '../styles/pages.css';
import CountryList from 'react-select-country-list';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import { PhoneNumberUtil } from 'google-libphonenumber';
// import { PhoneInput } from 'react-international-phone';
// import 'react-international-phone/lib/style.css';

const phoneUtil = PhoneNumberUtil.getInstance();

function VideoConsultation() {
    const [formData, setFormData] = useState({
        firstname: '',
        lastname: '',
        gender: '',
        email: '',
        country: '',
        phone: '',
        dob: '',
        op_number: '',
        messages: '',
        consent: false
    });

    const [errors, setErrors] = useState({});
    const [errorMessage, setErrorMessage] = useState('');
    const [successMessage, setSuccessMessage] = useState('');
    const [isSubmitted, setIsSubmitted] = useState(false); // New state variable to track form submission
    const options = CountryList().getData();
    const [phoneError, setPhoneError] = useState('');  // New state for phone number error

    const validateInput = (name, value) => {
        let error = '';
        switch (name) {
            case 'firstname':
            case 'lastname':
                if (!value.match(/^[A-Za-z\s]+$/)) {
                    error = 'This field should only contain alphabets.';
                }
                break;
            case 'email':
                if (!value.match(/^\w+@[a-zA-Z_]+?\.[a-zA-Z]{2,3}$/)) {
                    error = 'Please enter a valid email address.';
                }
                break;
            // case 'phone':
            //     try {
            //         // Ensure phone number starts with '+'
            //         const phoneNumber = value.startsWith('+') ? value : `+${value}`;
            //         console.log('Validating phone number:', phoneNumber); // Log the updated phone number
                    
            //         const number = phoneUtil.parseAndKeepRawInput(phoneNumber); // Parse the phone number
                    
            //         if (!phoneUtil.isValidNumber(number)) {
            //             error = 'Please enter a valid phone number.';
            //         }
            //     } catch (e) {
            //         console.error('Phone number parsing failed:', e.message);
            //         error = 'Please enter a valid phone number with a country code.';
            //     }
            //     break;


            // case 'phone':
            //     try {
            //         const phoneNumber = value.startsWith('+') ? value : `+${value}`; // Ensure the number starts with '+'
            //         console.log('Validating phone number:', phoneNumber); // Log the phone number being validated

            //         const number = phoneUtil.parseAndKeepRawInput(phoneNumber); // Parse the phone number

            //         if (!phoneUtil.isValidNumber(number)) {
            //             error = 'Please enter a valid phone number.';
            //         }
            //     } catch (e) {
            //         console.error('Phone number parsing failed:', e.message);
            //         error = 'Please enter a valid phone number with a country code.';
            //     }
            //     break;


            case 'phone':
                try {
                    const phoneNumber = value.startsWith('+') ? value : `+${value}`; // Ensure the number starts with '+'
                    console.log('Validating phone number:', phoneNumber); // Log the phone number being validated
            
                    const number = phoneUtil.parseAndKeepRawInput(phoneNumber); // Parse the phone number
            
                    if (!phoneUtil.isValidNumber(number)) {
                        error = 'Please enter a valid phone number.';
                    }
                } catch (e) {
                    console.error('Phone number parsing failed:', e.message);
                    error = 'Please enter a valid phone number with a country code.';
                }
                break;
            

            // case 'phone':
            //     if (!value.match(/^\d{1,20}$/)) {
            //         error = 'Please enter a valid phone number with 7 to 16 digits.';
            //     }
            //     break;


            default:
                break;
        }
        return error;
    };

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        const error = validateInput(name, value);
        setErrors({
            ...errors,
            [name]: error
        });
        setFormData({
            ...formData,
            [name]: type === 'checkbox' ? checked : value
        });
    };

    const handlePhoneChange = (phone) => {
        const error = validateInput('phone', phone);  // Validate phone number here
        setErrors({
            ...errors,
            phone: error
        });
        setFormData({
            ...formData,
            phone
        });
    };


    // const isPhoneValid = (phone) => {
    //     try {
    //         return phoneUtil.isValidNumber(phoneUtil.parseAndKeepRawInput(phone));
    //     } catch (error) {
    //         return false;
    //     }
    // };
        

    // const handlePhoneChange = (phone) => {
    //     const isValid = isPhoneValid(phone);
    //     setErrors({
    //         ...errors,
    //         phone: isValid ? '' : 'Phone is not valid',
    //     });
    //     setFormData({
    //         ...formData,
    //         phone,
    //     });
    // };

    const handleSubmit = (e) => {
        e.preventDefault();
    
        const validationErrors = {};
        let isValid = true;
    
        Object.keys(formData).forEach((key) => {
            const error = validateInput(key, formData[key]);
            if (error) {
                isValid = false;
                validationErrors[key] = error;
            }
        });

        // Validate phone number
        // if (!isPhoneValid(formData.phone)) {
        //     validationErrors.phone = 'Phone is not valid';
        //     isValid = false;
        // }
    
        setErrors(validationErrors);
    
        if (!isValid) {
            return;
        }
    
        fetch('https://caritasmathahospital.com/wp-content/themes/my_react_theme/api/video_consultation_form.php', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(formData),
        })
        .then(response => response.json())
        .then(data => {
            if (data.status === 'success') {
                setSuccessMessage(data.message);
                setErrorMessage(''); // Clear any previous error message
                setIsSubmitted(true); // Set the form as submitted
                setFormData({ // Reset form fields
                    firstname: '',
                    lastname: '',
                    gender: '',
                    email: '',
                    country: '',
                    phone: '',
                    dob: '',
                    op_number: '',
                    messages: '',
                    consent: false
                });
                setErrors({}); // Clear any previous validation errors
            } else {
                setErrorMessage(data.message);
                setSuccessMessage(''); // Clear any previous success message
            }
        })
        .catch((error) => {
            setErrorMessage('An error occurred. Please try again later.');
            setSuccessMessage(''); // Clear any previous success message
        });
    };


    return (
        <div>
            {/* Navbar */}
            <Navbar />
            {/* Navbar Ending */}

            {/* Page Content starts here */}
            <section className="page-section">
                <div className="section-content">
                    <p className='page-heading'>Video Consultation</p>

                    <div className="d-none d-md-block"> {/* Only works in Desktop */}
                        <p className="page-subtitle">
                            Discover convenient, personalized healthcare solutions 
                            <br/>
                            through video consultations.
                        </p>
                    </div>

                    <div className="d-md-none mb-2">{/* Only works in mobiles */}
                        <p className="page-subtitle">
                            Discover convenient, personalized healthcare solutions through video consultations.
                        </p>
                    </div>

                    <div className="page-box">
                        <div className="box-content">
                            <p>
                            Experience a new era of healthcare with Caritas Video Consultation, bringing quality medical care directly to you. Our interactive video consultations provide convenient access to expert medical advice, even in remote areas, bridging the gap in healthcare accessibility.
                            </p>
                        </div>
                        <div className="box-image">
                            <img src={BannerImage} alt="Video Consultation Banner" />
                        </div>
                    </div>
                </div>
            </section>

            <section className="page-content-section">
                <div className='page-content'>
                    <div className='page-details'>
                        <p className='video-content-heading'>How It Works</p>
                        <br/>

                        <p className="subtitle">Fill up the online form or call us to book your appointment.</p>

                        <ul>
                            <li>Begin the process by filling out the online form with your details or reach us at <a href='tel:+91 99468 56789'>+91 99468 56789</a></li>
                            <li>This step is your initial point of contact to schedule a video consultation.</li>
                        </ul>

                        <br/>
                        <p className="subtitle">Choose a convenient schedule for appointments.</p>

                        <ul>
                            <li>After you submit the form, our team will promptly contact you to provide available time slots and options.</li>
                            <li>Select a date and time that suits your availability from the available options</li>
                        </ul>

                        <br/>
                        <p className="subtitle">Make payment online, using the link shared through Email/SMS.</p>

                        <ul>
                            <li>After selecting your appointment, you will receive a secure payment link through Email and SMS.</li>
                            <li>Click on the link to proceed with the online payment process.</li>
                        </ul>

                        <br/>
                        <p className="subtitle">After successful payment, appointments will be confirmed.</p>

                        <ul>
                            <li>Once your payment is successfully processed, your appointment will be confirmed.</li>
                            <li>You will receive a confirmation notification through Email and SMS.</li>
                        </ul>

                        <br/>
                        <p className="subtitle">Make video consultation using the link shared, on a given time schedule.</p>

                        <ul>
                            <li>On the scheduled date and time, click the link provided for your video consultation.</li>
                            <li>Ensure you have a stable internet connection and a compatible device for the video call.</li>
                        </ul>
                    </div>
                
                    <br/>
                    <br/>
                    {!isSubmitted ? (
                        <div className="video-form">
                            <p className='video-form-heading'>Book Your Consultation</p>

                            <form onSubmit={handleSubmit} className="consultation-form">
                                <div className="form-fields">
                                    <label style={{ color: 'red' }}>*</label>
                                    <input type="text" name="firstname" value={formData.firstname} onChange={handleChange} placeholder='First Name' required />
                                    {errors.firstname && <div style={{ color: 'red' }}>{errors.firstname}</div>}
                                </div>
                                <div className="form-fields">
                                    <label style={{ color: 'red' }}>*</label>
                                    <input type="text" name="lastname" value={formData.lastname} onChange={handleChange} placeholder='Last Name' required />
                                    {errors.lastname && <div style={{ color: 'red' }}>{errors.lastname}</div>}
                                </div>
                                <div>
                                    <input type="radio" name="gender" value="Male" onChange={handleChange} required /> Male
                                    <input type="radio" className='gender' name="gender" value="Female" onChange={handleChange} required /> Female
                                    <input type="radio" className='gender' name="gender" value="Other" onChange={handleChange} required/> I don't want to specify
                                </div>
                                <div className="form-fields">
                                    <label style={{ color: 'red' }}>*</label>
                                    <input type="email" name="email" value={formData.email} onChange={handleChange} placeholder='Email' required />
                                    {errors.email && <div style={{ color: 'red' }}>{errors.email}</div>}
                                </div>
                                <div className='country'>
                                    <label style={{ color: 'red' }}>*</label>
                                    <select name="country" value={formData.country} onChange={handleChange} placeholder='Select Country' required>
                                        <option value="">Select Country</option>
                                        {options.map((country, index) => (
                                            <option key={index} value={country.label}>{country.label}</option>
                                        ))}
                                    </select>
                                </div>

                                {/* <div className='phone-number'>
                                    <label style={{ color: 'red' }}>*</label>
                                    <input type="text" name="phone" value={formData.phone} onChange={handleChange} placeholder='Phone Number' required pattern="\d*" onInput={(e) => e.target.value = e.target.value.replace(/[^0-9]/g, '')} />
                                </div> */}
                                
                                {/* <div className='phone-number'>
                                    <label style={{ color: 'red' }}>*</label>
                                    <PhoneInput
                                        country={'in'}  // Default country (you can change this)
                                        value={formData.phone}
                                        onChange={phone => setFormData({ ...formData, phone })}
                                        enableSearch={true}
                                        placeholder="Enter phone number"
                                        required
                                    />
                                    {errors.phone && <div style={{ color: 'red' }}>{errors.phone}</div>}
                                </div> */}
                                
                                {/* <div className='phone-number'>
                                    <label style={{ color: 'red' }}>*</label>
                                    <PhoneInput
                                        country={'in'}
                                        name="phone"
                                        value={formData.phone}
                                        onChange={handleChange} // Ensure the phone change is handled here
                                        enableSearch={true}
                                        placeholder="Enter phone number"
                                        required
                                        international
                                        countryCallingCodeEditable={false}
                                    />
                                    {errors.phone && <div style={{ color: 'red' }}>{errors.phone}</div>}  {/* Display error here */}
                                {/* </div> */}


                                <div className='phone-number'>
                                    <label style={{ color: 'red' }}>*</label>
                                    <PhoneInput
                                        name="phone"
                                        country={'in'}
                                        value={formData.phone}
                                        onChange={(phone) => {
                                            console.log('Phone number entered:', phone);
                                            setFormData({ ...formData, phone }); // Set phone in international format
                                            setErrors({ ...errors, phone: validateInput('phone', phone) }); // Validate the phone immediately
                                        }}
                                        enableSearch={true}
                                        placeholder="Enter phone number"
                                        required
                                        international
                                        countryCallingCodeEditable={false}
                                    />
                                    {errors.phone && <div style={{ color: 'red' }}>{errors.phone}</div>}  {/* Display error here */}
                                </div>


                                <div className="dob">
                                    <label>DOB:</label>
                                    <input
                                        type="date"
                                        name="dob"
                                        value={formData.dob}
                                        onChange={handleChange}
                                        required
                                        max={new Date().toISOString().split("T")[0]}  // Set max to today's date
                                    />
                                </div>

                                
                                <div className="op-number">
                                    <input type="text" name="op_number" value={formData.op_number} placeholder='Hospital OP Number (if available)' onChange={handleChange} />
                                </div>
                                

                                <div>
                                    <textarea 
                                        name="messages" 
                                        value={formData.messages} 
                                        rows="3" 
                                        onChange={handleChange} 
                                        placeholder='If you have any additional details or specific requirements you would like to share, please utilize this space.' 
                                        maxLength="500"  // Limit the number of characters to 500 (or any value you prefer)
                                    />
                                </div>

                                <div className='consent'>
                                    <label>
                                        <input type="checkbox" name="consent" checked={formData.consent} onChange={handleChange} required />
                                        By ticking, I agree to the terms and conditions, and I give my consent to receive updates through emails and SMS.
                                    </label>
                                </div>
                                <br/>
                                <button type="submit" className='form-button'>Submit</button>
                            </form>

                            {errorMessage && <div className="error-message" style={{ color: 'red' }}>{errorMessage}</div>}
                            {successMessage && <div className="success-message" style={{ color: 'green' }}>{successMessage}</div>}
                        </div>
                    ) : (
                        <div className="success-message">
                            <h1>Thank You!</h1>
                            <p>Your message has been successfully submitted.</p>
                        </div>
                    )}
                </div>

                <div className="more-services">
                    <p className="more-services-heading">More Services</p>
                    <div className='more-services-links'>
                        <a href="/radiology-laboratory"><p> Radiology & Laboratory</p></a>
                        <a href="/blood-bank"><p> Blood Bank</p></a>
                        <a href="/clinical-nutrition"><p> Clinical Nutrition</p></a>
                        <a href="/insurance-partners"><p> Insurance Partners</p></a>
                        <a href="/caritas-mortuary-services"><p> Caritas Mortuary Services</p></a>
                        <a href="/pastoral-care"><p> Pastoral Care</p></a>
                        <a href="/caritas-home-care"><p> Caritas Home Care</p></a>
                        <a href="https://www.caritashospital.org/health-checkup-packages"><p> Health Checkup Packages</p></a>
                    </div>
                </div>
            </section>


            {/* Page content ends here */}

            {/* Footer */}
            <Footer />
            {/* Footer Ending */}
        </div>
    );
}

export default VideoConsultation;
